module.exports = __webpack_public_path__ + "img/1.0162c88b.jpg";